import { Media, Pricing, SocialReportDetail } from "core/types/social.types";
import { ApiFactoryClients } from "../api.types";
import {
  transformMediaList,
  transformPricing,
  transformProfileList,
  transformSocialReportDetail,
} from "./social.helpers";
import { JSONMocked } from "./mocked-data";

// eslint-disable-next-line import/no-anonymous-default-export
export default ({ codeHttpClient }: ApiFactoryClients<"codeHttpClient">) => ({
  getProfiles: (): Promise<any> =>
    codeHttpClient
      .get("/social/user/profiles", {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
          "Meta-token": sessionStorage.getItem("Meta_Token"),
        },
      })
      .then(({ data }) => transformProfileList(data)),
  getPosts: (instagramId: string, page: number): Promise<Media[]> =>
    codeHttpClient
      .get(`/social/media?page=${page}&ig_page_id=${instagramId}`, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
          "Meta-token": sessionStorage.getItem("Meta_Token"),
        },
      })
      .then(({ data }) => transformMediaList(data)),
  getPricing: (instagramId: string, posts: string[]): Promise<Pricing> =>
    codeHttpClient
      .post(
        "/social/pricing",
        { ig_page_id: instagramId, posts: posts },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Meta-token": sessionStorage.getItem("Meta_Token"),
          },
        }
      )
      .then(({ data }) => transformPricing(data)),
  sendRequest: (body: {
    posts: string[];
    pricing_request_id: string;
    ig_page_id: string;
    level: number;
  }) =>
    codeHttpClient
      .post("/social/reports", body, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
          "Meta-token": sessionStorage.getItem("Meta_Token"),
        },
      })
      .then(({ data }) => data.message),
  getReportDetail: (fileId: number): Promise<SocialReportDetail> =>
    codeHttpClient
      .get("/social/reports?file_id=" + fileId, {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
          "Meta-token": sessionStorage.getItem("Meta_Token"),
        },
      })
      .then(({ data }) => transformSocialReportDetail(data)),
});
